import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const webhookChannel = defineChannel({
  id: 'webhook',
  icon: 'webhook',
} as const satisfies ChannelDefinition);
